// @flow
import Spinner from 'components/Spinner'
import useSignatureMemo from 'hooks/useSignatureMemo'
import PDFFiller from 'pages/PDFFiller'
import { useLoadBusinessAssociateAgreement } from 'queries/businessAssociateAgreement/useLoadBusinessAssociateAgreement'
import { useLoadResponse } from 'queries/responses/useLoadResponse'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import Flex from 'ui/atoms/Flex'
import Page from 'ui/organisms/Page'

import { invalidateLoadBusinessAssociateAgreements } from '../../../queries/businessAssociateAgreement/useLoadBusinessAssociateAgreement'

function BusinessAssociateAgreementPage(): React.Node {
  const history = useHistory()

  const {
    data: businessAssociateAgreement,
    isLoading: isLoadingBusinessAssociateAgreement,
    isFetching: isFetchingBusinessAssociateAgreement,
  } = useLoadBusinessAssociateAgreement()
  const signatureMemo = useSignatureMemo()
  const {
    data: response,
    isLoading: isResponseLoading,
    isFetching: isFetchingResponse,
  } = useLoadResponse(businessAssociateAgreement?.response_id, {
    enabled: !!businessAssociateAgreement?.response_id,
  })

  const isLoading =
    isLoadingBusinessAssociateAgreement ||
    isResponseLoading ||
    isFetchingBusinessAssociateAgreement ||
    isFetchingResponse

  return (
    <Page withBackButton>
      {isLoading ? (
        <Flex align="center" className="mt-10" justify="center">
          <Spinner color="onLight" size={100} />
        </Flex>
      ) : (
        <div className="flex-1 sm:mx-6">
          <PDFFiller
            hideHeader
            hideFooter={businessAssociateAgreement?.signed}
            overrideSuccessModal={() => {
              toast.success('Business Associate Agreement signed successfully')
              invalidateLoadBusinessAssociateAgreements()
              history.push('/profile')
            }}
            preloadedResponse={response?.document_response}
            resourceId={businessAssociateAgreement?.response_id}
            signatureMemo={signatureMemo}
            viewMode={businessAssociateAgreement?.signed ? 'response' : 'fill'}
          />
        </div>
      )}
    </Page>
  )
}

export default BusinessAssociateAgreementPage
